<form [formGroup]="formGroup">
  <div class="p-2">
    <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-400  ">Payment</h2>
    <p class="text-sm text-gray-500 dark:text-gray-100  ">All transactions are secured and encrypted.</p>

    <!-- Payment Method -->
    <div class="mt-4 border rounded-lg shadow-sm bg-gray-50 dark:bg-transparent ">
      <div class="flex items-center justify-between p-4 border
      bg-blue-50
      border-blue-700

      rounded-lg rounded-b-none

      dark:bg-brandOrange
      dark:text-white">
        <mat-radio-group class="flex items-center space-x-3">
          <mat-radio-button class="text-blue-600  dark:text-white focus:ring-blue-500" checked="true"></mat-radio-button>
          <span class="font-medium text-gray-800 dark:text-white  ">Credit or debit card</span>
        </mat-radio-group>
        <div class="flex space-x-2">
          <div class="bg-white rounded-lg p-2" [ngClass]="{'border-2 border-blue-700': creditCardNumberControl.value === 'visa'}">

            <img src="assets/cards/visa.svg" alt="Visa" class="h-5">
          </div>
          <div class="bg-white rounded-lg p-2" [ngClass]="{'border-2 border-blue-700':  creditCardNumberControl.value === 'mastercard'}">

            <img src="assets/cards/mastercard.svg" alt="MasterCard" class="h-5">
          </div>
          <div class="bg-white rounded-lg p-2" [ngClass]="{'border-2 border-blue-700':  creditCardNumberControl.value === 'amex'}">

            <img src="assets/cards/amex.svg" alt="Amex" class="h-5">
          </div>
        </div>
      </div>
      <!-- Card Details -->
      <div class="p-4 space-y-4">
        <mat-form-field class="w-full my-2" [subscriptSizing]="'dynamic'">
          <input
            matInput
            formControlName="credit_card_number"
            [placeholder]="'Card number'"
            (change)="validateCardNumber()"
          />
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
               stroke="currentColor"
               class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
          </svg>
        </mat-form-field>
        <div class="flex space-x-4">
          <mat-form-field class="flex-1 my-2" [subscriptSizing]="'dynamic'">
            <input
              matInput
              formControlName="expiration_date"
              [placeholder]="'Expiration date (MM/YY)'"
              pattern="^(0[1-9]|1[0-2])\/?([0-9]{2})$"
            />
          </mat-form-field>
          <mat-form-field class="flex-1 my-2" [subscriptSizing]="'dynamic'">
            <input
              matInput
              formControlName="credit_card_cvv"
              type="text"
              [placeholder]="'Security code'"
              maxlength="4"
              pattern="[0-9]*"
              inputmode="numeric"
            />
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                 stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
            </svg>
          </mat-form-field>
        </div>
        <mat-form-field class="w-full my-2" [subscriptSizing]="'dynamic'">
          <input
            matInput
            formControlName="payer_name"
            [placeholder]="'Name on card'"
          />
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
               stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
          </svg>

        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Billing Address -->
  <div class="p-4">
    <!-- Billing Address -->
    <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-400  ">Billing Address</h2>
    <p class="text-sm text-gray-500 dark:text-gray-100 ">Select the address that matches your card or payment method.</p>

    <!-- Billing Address Options -->
    <mat-radio-group formControlName="useDefaultAddress" class="mt-4">
      <mat-radio-button class="flex items-center space-x-3 p-3 border rounded-lg rounded-b-none shadow-sm cursor-pointer dark:text-white"
                        [ngClass]="{'bg-blue-50  dark:bg-brandOrange border-blue-700' : formGroup?.get('useDefaultAddress')?.value}"
                        [value]="true">
        &nbsp;<span class="text-gray-800 dark:text-white">Same as default address</span>
      </mat-radio-button>
      <mat-radio-button
        class="flex items-center space-x-3 p-3 border rounded-lg rounded-t-none shadow-sm cursor-pointer"
        [ngClass]="{'bg-blue-50  dark:bg-brandOrange border-blue-700' : !formGroup?.get('useDefaultAddress')?.value}"
        [value]="false">
        &nbsp;<span class="text-gray-800 dark:text-white">Use a different billing address</span>
      </mat-radio-button>
    </mat-radio-group>

    <!-- Conditional Billing Address Form -->
    <div *ngIf="!formGroup?.get('useDefaultAddress')?.value" class="mt-6 space-y-4">
      <sbd-app-address-form [showCounty]="false" [formGroup]="formGroup">
      </sbd-app-address-form>
    </div>
  </div>
</form>
